<div class="agent-container" *ngIf="agent">
  <!-- Header -->
  <div class="header">
    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <!-- Go Back Action -->
      <button class="action-btn secondary-btn icon-btn" (click)="goBack()">
        <span class="icon">
          <img src="assets/icones/navigate-back-arrow.svg" alt="" />
        </span>
      </button>
      <span>
        <div class="breadcrumb-item">{{ "agent.title" | translate }}</div>
      </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span class="truncate" style="max-width: 400px; font-weight: 600" [title]="agent.first_name + ' ' + agent.last_name">
        {{ agent.first_name + " " + agent.last_name }}
      </span>
    </div>
    <!-- Create Agent Catalog Action -->
    <button class="action-btn primary-btn" (click)="goToNewCatalog()">
      <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
      <span>{{ "agent.actions.create_catalog" | translate }}</span>
    </button>
  </div>
  <!-- Content -->
  <div class="agent-content">
    <!-- Left Panel -->
    <div class="left-panel">
      <!-- Tabs -->
      <div class="tabs">
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="leftPanelActiveTab === 'orders'"
          [class.active]="leftPanelActiveTab === 'orders'"
          (click)="leftPanelActiveTab = 'orders'"
        >
          {{ "agent.listing.orders" | translate }}
        </div>
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="leftPanelActiveTab === 'portfolio'"
          [class.active]="leftPanelActiveTab === 'portfolio'"
          (click)="leftPanelActiveTab = 'portfolio'"
        >
          {{ "agent.listing.portfolio" | translate }}
        </div>
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="leftPanelActiveTab === 'catalogs'"
          [class.active]="leftPanelActiveTab === 'catalogs'"
          (click)="leftPanelActiveTab = 'catalogs'"
        >
          {{ "agent.single_agent.tabs.catalogs" | translate }}
        </div>
        <div
          class="action-buttons-group"
          style="
            margin-left: auto;
            display: flex;
            gap: 20px;
            align-items: center;
          "
        >
          <ng-container *ngIf="leftPanelActiveTab === 'portfolio'">
            <span class="secondary-text" style="text-align: center;">
              {{ agent.companies_ids!.length }} companies
            </span>
            <span class="secondary-text" style="text-align: center;"> {{ totalLocations }} locations </span>
            <div style="display: flex; gap: 10px; align-items: center">
              <button
                *ngIf="agent.companies_ids!.length"
                class="action-btn secondary-btn"
                style="color: #6449DB;"
                (click)="onAddPortfolio()"
              >
                <span class="icon"
                  ><app-svg-icon svgIcon="plus-cc"></app-svg-icon
                ></span>
                <span class="action-text">{{ "agent.actions.add_company" | translate }}</span>
              </button>
              <button
                *ngIf="showDeleteButton"
                class="action-btn secondary-btn icon-btn"
                style="border-color: #970000"
                (click)="onDeleteLocations()"
              >
                <span class="icon">
                  <app-svg-icon
                    svgIcon="trash-cc"
                    style="color: #970000"
                  ></app-svg-icon>
                </span>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="leftPanelActiveTab === 'catalogs'">
            <span class="secondary-text">
              {{ agent.pricelist_ids!.length }} catalogs
            </span>
            <div style="display: flex; gap: 10px; align-items: center">
              <button
                *ngIf="agent.pricelist_ids!.length"
                class="action-btn secondary-btn"
                style="color: #6449DB;"
                (click)="onAddCatalogs()"
              >
                <span class="icon"
                  ><app-svg-icon svgIcon="plus-cc"></app-svg-icon
                ></span>
                <span class="action-text">{{ "agent.actions.add_catalog" | translate }}</span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Tab Content -->
      <div class="tab-content-wrapper">
        <!-- Orders -->
        <app-agent-orders
          *ngIf="leftPanelActiveTab === 'orders'"
          [active_date_filter]="active_date_filter"
          (goToTab)="leftPanelActiveTab = $event"
          (dateFilterChanged)="onDateFilterChanged($event)"
          @slideInOut
        ></app-agent-orders>
        <!-- Portfolio -->
        <app-agent-portfolio
          *ngIf="leftPanelActiveTab === 'portfolio'"
          (selectedLocationsChanged)="onSelectedLocationsChanged($event)"
          [triggerDelete]="triggerDeletePortfolio"
          [triggerAddPortfolio]="triggerAddPortfolio"
          @slideInOut
        ></app-agent-portfolio>
        <!-- Catalogs/Incentives -->
        <app-agent-catalogs
          *ngIf="leftPanelActiveTab === 'catalogs'"
          [triggerAddCatalogs]="triggerAddCatalogs"
          @slideInOut
        ></app-agent-catalogs>
      </div>
    </div>
    <div class="right-panel">
      <div class="tabs">
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'details'"
          [class.active]="rightPanelActiveTab === 'details'"
          (click)="rightPanelActiveTab = 'details'"

        >
          {{ "agent.single_agent.tabs.details" | translate }}
        </div>
        <!-- TODO: Uncomment when contract tab is implemented -->
        <!-- <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'contract'"
          [class.active]="rightPanelActiveTab === 'contract'"
          style="cursor: not-allowed"
        >
          {{ "agent.single_agent.tabs.contract" | translate }}
        </div> -->
      </div>
      <div class="tab-content-wrapper">
        <app-agent-informations *ngIf="rightPanelActiveTab === 'details'" @slideInOut></app-agent-informations>
        <div *ngIf="rightPanelActiveTab === 'contract'" @slideInOut>
          Contract content here
        </div>
      </div>
    </div>
  </div>
</div>
